import toast from 'react-hot-toast'

/**
 * Utilitaires pour les notifications toast
 * Style: Cyber/Terminal unifié avec App.jsx Toaster config
 */

export const showSuccess = (message) => {
  toast.success(message, {
    duration: 3000,
  })
}

export const showError = (message) => {
  toast.error(message, {
    duration: 4000,
  })
}

export const showInfo = (message) => {
  toast(message, {
    duration: 3000,
    icon: 'ℹ️',
  })
}

export const showWarning = (message) => {
  toast(message, {
    duration: 3500,
    icon: '⚠️',
    style: {
      color: 'var(--color-warning)',
      border: '1px solid var(--color-warning)',
    },
  })
}

export const showLoading = (message) => {
  return toast.loading(message)
}

export const dismissToast = (toastId) => {
  toast.dismiss(toastId)
}

export const updateToast = (toastId, { type, message }) => {
  if (type === 'success') {
    toast.success(message, { id: toastId })
  } else if (type === 'error') {
    toast.error(message, { id: toastId })
  } else {
    toast(message, { id: toastId })
  }
}
